import request from '../utils/request';
//登录
export function doLogin(data) {
  return request({
    url: 'user/login.html',
    method: 'post',
    data
  });
}

// 首页数据
export function getInfo() {
  return request({
    url: 'webIndex/info.html',
    method: 'get',
  });
}

